import React, { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { AboutShowcase } from "../components/AboutShowcase";
import { Services } from "../components/Services";
import { WhyChoose } from "../components/WhyChoose";
import { FeaturedPackages } from "../components/FeaturedPackages";
import { DestinationShowcase } from "../components/DestinationShowcase";
import { FleetIntro } from "../components/FleetIntro";
import { FleetShowcase } from "../components/FleetShowcase";
import { Footer } from "../components/Footer";
import { Booking } from "../components/Booking";

export const HomePage = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [bookingData, setBookingData] = useState(null);

  const handleBookNow = (data) => {
    setBookingData(data);
    setCurrentPage('booking');
  };

  const handleBackFromBooking = () => {
    setCurrentPage('home');
    setBookingData(null);
  };

  if (currentPage === 'booking') {
    return <Booking onBack={handleBackFromBooking} {...bookingData} />;
  }

  return (
    <div className="HomePage">
      <Navbar />
      <Hero />
      <AboutShowcase />
      <Services onBookNow={handleBookNow} />
      <WhyChoose />
      <FeaturedPackages />
      <DestinationShowcase />
      <FleetIntro />
      <FleetShowcase onBookNow={handleBookNow} />
      <Footer />
    </div>
  );
};
